<ng-content />

<button
  class="px-1 pt-1 text-ui-gray-light cursor-pointer h-[30px] w-[30px] align-middle"
  (click)="copy()"
  [cdkCopyToClipboard]="value()"
  [matTooltip]="tooltipMessage()"
>
  <mat-icon
    class="text-base cursor-pointer p-0 pt-0.5 text-ui-gray-dark active:text-ui-green-light"
    fontIcon="content_copy"
  />
</button>
